import app from 'flarum/common/app';

app.initializers.add('indigo/empresa', () => {
  console.log('[indigo/empresa-common] Hello, forum and admin!');
});
